var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHairL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 197,
    viewBox: "0 0 153 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.675 143.175C18.8599 148.067 13 157.289 13 171C13 180.701 15.9336 189.575 21.1257 196.398C31.9824 192.726 43.6597 188.887 54 185.87V164.975C43.1738 160.738 34.739 153.279 28.675 143.175Z",
    className: "Hair"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0016 28.9278C92.787 27.9927 101.308 18.0228 101.96 2.00276C102.005 0.899107 101.099 -0.000473288 99.9945 0.000674621C78.4431 0.0230717 78.0085 0.78904 78.0002 26.9847C77.9998 28.0893 78.9 29.0084 80.0016 28.9278Z",
    className: "Hair"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77387 103.972C6.51608 104.013 4.23236 104.079 1.92353 104.169C0.819798 104.212 -0.0477043 105.187 0.00203684 106.291C1.71357 144.261 2.67834 155.953 41.4369 157.829C33.8404 151.878 28.0245 143.703 23.9759 133.679C22.8768 133.89 21.7433 134 20.5849 134C10.4145 134 7 125.493 7 115C7 110.888 7.52428 107.081 8.77387 103.972ZM112.697 157.724C149.533 155.545 150.494 143.612 152.176 106.291C152.226 105.187 151.358 104.212 150.254 104.169C148.57 104.103 146.899 104.05 145.242 104.011C146.48 107.113 147 110.905 147 115C147 125.493 143.585 134 133.415 134C132.257 134 131.123 133.89 130.024 133.679C125.999 143.645 120.228 151.782 112.697 157.724Z",
    className: "HairDark"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9929 16.0159C39.6105 70.4647 23.7118 105.863 1.99862 107.906C0.898908 108.01 -4.75116e-05 107.055 0.000480792 105.95C0.0443842 14.1577 3.1651 13.9754 37.9764 14.0007C39.0809 14.0015 40.0007 14.9114 39.9929 16.0159Z",
    className: "Hair"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00529 106.984C1.28926 53.0854 12.9764 17.8545 29.0088 15.1657C30.0981 14.983 31 15.9453 30.9996 17.0498C30.9669 108.26 28.6558 109.019 3.01209 109C1.90752 108.999 0.999466 108.089 1.00529 106.984Z",
    className: "Hair"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.995 106.984C151.711 53.0854 140.024 17.8545 123.991 15.1657C122.902 14.983 122 15.9453 122 17.0498C122.033 108.26 124.344 109.019 149.988 109C151.092 108.999 152.001 108.089 151.995 106.984Z",
    className: "Hair"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.007 16.0159C112.39 70.4647 128.288 105.863 150.001 107.906C151.101 108.01 152 107.055 152 105.95C151.956 14.1577 148.835 13.9754 114.024 14.0007C112.919 14.0015 111.999 14.9114 112.007 16.0159Z",
    className: "Hair"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1703 14.0001L109.972 14.0001C140.762 14.0002 143.925 45.8462 141.248 60C96.9864 60 79.7232 48.3735 76.9857 25.3847C74.7908 48.3735 52.5952 60 12.1043 60C7.58732 47.868 17.2368 14.0001 35.3697 14C55.9519 14 72.9621 14 90.1703 14.0001Z",
    className: "Hair"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairL);
export default __webpack_public_path__ + "static/media/Hair L.2bb682762a2a81cf201980eeab62555e.svg";
export { ForwardRef as ReactComponent };